import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { useErrorMessage } from "@/lib/errors";

/**
 * The one way a mutation fails: a toast in the reader's language.
 *
 * Lives on its own because admin settings and account management both need it,
 * and two copies would drift the first time one of them grew a special case.
 */
export function useFailureToast() {
  const { t } = useTranslation();
  const describe = useErrorMessage();
  return useCallback(
    (error: unknown) => toast.error(describe(error) ?? t("common.somethingWentWrong")),
    [describe, t],
  );
}
